import React, { useState } from 'react'
import { Button, Card, Alert } from 'antd'
import MySpecializations from '@components/Platform/Settings/MySpecializations'
import useSignupAnalyticsTracker from '@components/Signup/SegmentAnalytics/useSignupAnalyticsTracker'
import useSignupPageView from '@components/Signup/SegmentAnalytics/useSignupPageView'

import './Specializations.scss'

const Specializations = ({ goToPreviousStep, goToNextStep, stepName, nextStepName }) => {
  useSignupPageView('Account Setup Specializations')
  const track = useSignupAnalyticsTracker()

  const [showValidation, setShowValidation] = useState(false)

  const handleSaveSuccess = (payload) => {
    if (payload && payload.is_specializations_complete) {
      track({ eventName: `Account Setup ${nextStepName} Button Clicked ${stepName}` })
      goToNextStep()
    } else {
      setShowValidation(true)
    }
  }

  const handleBack = () => {
    track({ eventName: `Account Setup Back Button Clicked ${stepName}` })
    goToPreviousStep()
  }

  return (
    <div className="specializations" data-testid="signup-specializations-step">
      <Card>
        {showValidation && (
          <Alert
            type="error"
            message="Please complete all sections to continue"
            className="specializations__validation"
            data-testid="specializations-validation-message"
          />
        )}
        <MySpecializations
          hideBadge
          saveButtonLabel={nextStepName}
          onSaveSuccess={handleSaveSuccess}
        />
      </Card>

      <Card style={{ marginTop: '5px' }}>
        <div className="controls">
          <Button
            name="back"
            onClick={handleBack}
            type="default"
            data-testid="signup-specializations-back-button"
          >
            Back
          </Button>
        </div>
      </Card>
    </div>
  )
}

export default Specializations
